/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react';
import 'leaflet/dist/leaflet.css';
import { MapContainer, TileLayer } from 'react-leaflet';

import WhiteMarker from 'assets/images/marker/white.svg';
import MapMarker from 'components/MapMarker';
import MapUserMarker from 'components/MapUserMarker';
import ResetLocationButton from 'components/ResetLocationButton';
import { useStore } from 'hooks';
import { LatLngTuple } from 'leaflet';

import { IMap, TLocation } from './interfaces';
import { Container, Header } from './styles';

export const Map: React.FC<IMap> = ({
  positions,
  mapPermission,
  currentSelected,
  getUserLocation,
  changeCurrentSelected,
}) => {
  const isEqual = (arr1: LatLngTuple, arr2: LatLngTuple) => {
    return JSON.stringify(arr1) === JSON.stringify(arr2);
  };

  const { userPosition, searchedLocation } = useStore();
  return (
    <Container id="mapContainer" data-testid="mapContainer">
      {!mapPermission && (
        <Header onClick={getUserLocation}>
          <div>
            <img
              src={WhiteMarker}
              alt="Marcador indicando que deve ser ligada a localização do dispositivo"
            />
            Usar minha localização
          </div>
        </Header>
      )}

      <MapContainer
        id="map"
        center={currentSelected.location || [-23.5636453, -46.6528831]}
        zoom={12}
        scrollWheelZoom
      >
        <TileLayer url="https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png" />
        <MapUserMarker userPosition={userPosition.position} />
        {searchedLocation && (
          <MapMarker position={searchedLocation} isFromSearch />
        )}
        {positions.map((position: TLocation) => (
          <MapMarker
            isActive={!!isEqual(position.positions, currentSelected.location)}
            key={position.id}
            index={position.id}
            position={position.positions}
            changeCurrentSelected={changeCurrentSelected}
          />
        ))}
        {userPosition.isSharing && (
          <ResetLocationButton userPosition={userPosition.position} />
        )}
      </MapContainer>
    </Container>
  );
};
